import JsBarcode from 'jsbarcode'

function textToBase64Barcode(text: string, displayValue?: boolean) {
  const canvas = document.createElement('canvas')
  JsBarcode(canvas, text, { format: 'CODE128', displayValue: displayValue ?? false })
  return canvas.toDataURL('image/png')
}

export default textToBase64Barcode
